import {connect} from 'react-redux';
import { findIndex } from 'lodash';
import {ResultsComparisonGel as Component} from './ResultsComparisonGel';
import {} from '@learningblocks/protocol-redux/lib/Actions';

function mapStateToProps(state, ownProps) {

  return {
    gelDragDropPrediction: state.notebook.levelData.PREDICTIONS.components[findIndex(state.notebook.levelData.PREDICTIONS.components, {type: "GEL_DRAG_DROP_QUESTION"})],
    interactionProps: {
      solutions: state.notebook.protocolSection.scene.apparatus.solutions,
      agaroseGel: state.notebook.protocolSection.scene.apparatus.agaroseGel
    },
    // gelExamined: state.notebook.protocolSection.scene.apparatus.transilluminator[0].gelExamined,
    level: state.notebook.levelSelected.id,
    gelOrientation: state.notebook.protocolSection.scene.apparatus.gelBoxes[0].gelOrientation
  }

}

function mapDispatchToProps(dispatch) {
  return {};
}

export const ResultsComparisonGel = connect(
  mapStateToProps,
  mapDispatchToProps
)(Component);
